/* WSQ Theme — Lazy Video Loader with thumbnail → video swap + fallback */

document.addEventListener('DOMContentLoaded', () => {
  initLazyVideos();
  initVideoPlayButtons();
});

function initLazyVideos() {
  const wrappers = document.querySelectorAll('[data-lazy-video]');
  if (!wrappers.length) return;

  /* Hero video (above fold) — load immediately on desktop only.
     Skip the heavy 720p HLS hero video on mobile, data-saver, and slow
     connections: the eager poster image IS the hero there. This saves
     ~14MB of above-the-fold download on mobile and is the single biggest
     mobile PageSpeed / LCP win. Desktop keeps the full background video. */
  const conn = navigator.connection || {};
  const skipHeavyHeroVideo =
    window.matchMedia('(max-width: 768px)').matches ||
    conn.saveData === true ||
    /(^|-)(slow-2g|2g)$/.test(conn.effectiveType || '');

  wrappers.forEach(wrapper => {
    if (wrapper.closest('.hero-section') && !skipHeavyHeroVideo) {
      loadVideo(wrapper);
    }
  });

  /* All other videos — load only when scrolled into view */
  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2 }
  );

  wrappers.forEach(wrapper => {
    if (!wrapper.closest('.hero-section')) {
      observer.observe(wrapper);
    }
  });
}

function loadVideo(wrapper) {
  const video = wrapper.querySelector('video');
  const thumbnail = wrapper.querySelector('.video-wrapper__thumbnail');
  const playBtn = wrapper.querySelector('.video-wrapper__play-btn');

  if (!video) return;
  if (wrapper.dataset.loaded) return; /* prevent double-loading */
  wrapper.dataset.loaded = 'true';

  /* Move src from data-src → src on each <source> */
  video.querySelectorAll('source[data-src]').forEach(source => {
    source.src = source.dataset.src;
    source.removeAttribute('data-src');
  });

  video.load();

  /* Trigger play as soon as browser has enough data */
  video.addEventListener('canplay', () => {
    video.play().catch(() => {
      showFallback(wrapper, thumbnail, playBtn);
    });
  }, { once: true });

  /* Fade thumbnail only when first frame is actually on screen */
  video.addEventListener('playing', () => {
    hideThumbnail(thumbnail);
    if (playBtn) {
      playBtn.style.opacity = '0';
      playBtn.style.pointerEvents = 'none';
    }
  }, { once: true });

  /* FALLBACK 1: video file error (broken URL, unsupported format) */
  video.addEventListener('error', () => {
    showFallback(wrapper, thumbnail, playBtn);
  }, { once: true });

  /* FALLBACK 2: timeout — if video hasn't started playing in 8s, keep thumbnail */
  const timeout = setTimeout(() => {
    if (video.paused) showFallback(wrapper, thumbnail, playBtn);
  }, 8000);

  video.addEventListener('playing', () => clearTimeout(timeout), { once: true });
}

function hideThumbnail(thumbnail) {
  if (!thumbnail) return;
  thumbnail.style.transition = 'opacity 0.8s ease';
  thumbnail.style.opacity = '0';
  setTimeout(() => {
    thumbnail.style.display = 'none';
  }, 800);
}

function showFallback(wrapper, thumbnail, playBtn) {
  /* Keep thumbnail visible — it IS the fallback */
  if (thumbnail) {
    thumbnail.style.opacity = '1';
    thumbnail.style.display = 'block';
  }
  /* Show play button so user can manually try */
  if (playBtn) {
    playBtn.style.opacity = '1';
    playBtn.style.pointerEvents = 'auto';
  }
  wrapper.dataset.loaded = ''; /* allow retry on play button click */
}

function initVideoPlayButtons() {
  document.querySelectorAll('.video-wrapper__play-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.video-wrapper');
      const video = wrapper.querySelector('video');
      const thumbnail = wrapper.querySelector('.video-wrapper__thumbnail');

      if (!video) return;

      if (video.paused) {
        /* Re-trigger load if sources were never set */
        const needsLoad = !video.querySelector('source[src]');
        if (needsLoad) {
          loadVideo(wrapper);
          return;
        }
        video.play().catch(() => {});
        hideThumbnail(thumbnail);
        btn.style.opacity = '0';
        btn.style.pointerEvents = 'none';
      } else {
        video.pause();
        if (thumbnail) {
          thumbnail.style.display = 'block';
          thumbnail.style.opacity = '1';
        }
        btn.style.opacity = '1';
        btn.style.pointerEvents = 'auto';
      }
    });
  });
}
